// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-container {
  width: 100%;
  height: 50px;
}

#mobile-layout .search-container {
  margin-top: 10px;
}

.search-container .search-area {
  width: 90%;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  display: flex;
}

.search-container .search-area .options.trigger {
  margin-left: 5px;
}

.search-container .search-area .options.trigger .button {
  padding-left: 15px;
  padding-right: 5px;
  height: 100%;
}

.search-container .search-area .ui.input.action {
  flex: 1;
}

.search-area,
.search-area .react-autosuggest__container,
.search-container .search-area .ui.input.action {
  flex: 1;
}

.search-area,
.search-area input {
  width: 100%;
}

.search-area button {
  display: inline-block !important;
}

.search-layout {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.search-layout .virtual-table {
  height: calc(100% - 50px);
}

@media only screen and (min-width: 767px) {
  .result.modal td {
    max-width: 250px;
  }
}

.search-options {
  min-width: 300px;
}

.search-options .field-hub_urls {
  max-height: 180px;
  overflow-y: auto;
}
`, "",{"version":3,"sources":["webpack://./src/routes/Search/style.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,OAAO;AACT;;AAEA;;;EAGE,OAAO;AACT;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB","sourcesContent":[".search-container {\n  width: 100%;\n  height: 50px;\n}\n\n#mobile-layout .search-container {\n  margin-top: 10px;\n}\n\n.search-container .search-area {\n  width: 90%;\n  max-width: 600px;\n  margin-left: auto;\n  margin-right: auto;\n  display: flex;\n}\n\n.search-container .search-area .options.trigger {\n  margin-left: 5px;\n}\n\n.search-container .search-area .options.trigger .button {\n  padding-left: 15px;\n  padding-right: 5px;\n  height: 100%;\n}\n\n.search-container .search-area .ui.input.action {\n  flex: 1;\n}\n\n.search-area,\n.search-area .react-autosuggest__container,\n.search-container .search-area .ui.input.action {\n  flex: 1;\n}\n\n.search-area,\n.search-area input {\n  width: 100%;\n}\n\n.search-area button {\n  display: inline-block !important;\n}\n\n.search-layout {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.search-layout .virtual-table {\n  height: calc(100% - 50px);\n}\n\n@media only screen and (min-width: 767px) {\n  .result.modal td {\n    max-width: 250px;\n  }\n}\n\n.search-options {\n  min-width: 300px;\n}\n\n.search-options .field-hub_urls {\n  max-height: 180px;\n  overflow-y: auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
